import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';
import {
  AbstractControl,
  FormBuilder,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../shared/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { routes } from '../../../shared/routes/routes';
import { handleSubscriptionResponse } from '../../../shared/utils/subscription-response.util';
import moment from 'moment';
import { BookingLogService } from '../../../services/booking-log.service';
import { interval, switchMap, takeUntil, takeWhile, timer } from 'rxjs';
import { CONSTANT } from '../../../shared/constants/global-constant';

@Component({
  standalone: false,
  selector: 'app-book-tele-medicine',
  templateUrl: './book-tele-medicine.component.html',
  styleUrls: ['./book-tele-medicine.component.scss'],
})
export class BookTeleMedicineComponent {
  timer: any;
  alaCartPriceOption: boolean = false;
  currencyPrice: any = 0;
  timeElapsed: number = 0;
  subTelemedCount: number = 0;
  timeoutLimit: number = 5 * 60 * 1000;
  IncorrectPin: boolean = false;
  ErrorPin: boolean = false;
  showSuccess: boolean = false;
  proceedToPay: boolean = false;
  completeTelemedSub: boolean = false;
  onHoldPopup: boolean = false;
  minDate: any = '';
  maxDate: any = '';
  paymentStatus: any;
  home: boolean = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  teleMedicineConsultForm: any;
  bookingName: any;
  attemptsLeft: number = 3;
  patientList: any = [];
  userProfile: any;
  bookingConfirmed: any = false;
  slotsList: any[] = [];
  isMobile: boolean;
  notEligiblie: boolean = false;
  enterEcocashPIn: boolean = false;
  pinForm: any;
  @ViewChildren('pinInput') pinInputs!: QueryList<ElementRef>;
  bookingId: any;
  bookingForm: any;
  statusCode: any;
  errorMessage: any;
  isOpenModel: boolean = true;
  bsDatepickerConfig: any;
  remark: any;
  constant = CONSTANT;
  unlockMedicalList: any = [];
  userProfiles: any;
  showPin: boolean = false;
  billingNumber: any;
  slotUnavailable: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private apiService: ApiService,
    private tosterService: ToastrService,
    private commonService: CommonService,
    private bookingLogService: BookingLogService,
  ) {
    this.isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );
    this.pinForm = this.fb.group({
      pin0: ['', [Validators.required, Validators.pattern('[0-9]')]],
      pin1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      pin2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      pin3: ['', [Validators.required, Validators.pattern('[0-9]')]],
    });
    this.teleMedicineConsultForm = this.fb.group({
      slot_id: ['', Validators.required],
      consultation_type: ['', Validators.required],
      patient: [null, Validators.required],
      currency: ['', Validators.required],
      a_la_carte_price: [null],
      age: [null, [Validators.required, Validators.min(18)]],
      gender: [null, Validators.required],
      reason_for_consultation: ['', Validators.required],
      country_dial_code: [''],
      phone: [null, [Validators.required, this.zimbabweMobileValidator()]],
      appointment_date: ['', Validators.required],
      plan_consultation: ['', Validators.required],
      medical_report_id: [[]],
    });
    this.teleMedicineConsultForm.reset();
    this.teleMedicineConsultForm.get('gender')?.setValue('');
    this.teleMedicineConsultForm.get('currency')?.setValue('');
    this.teleMedicineConsultForm.get('age')?.enable();
    this.teleMedicineConsultForm.get('gender')?.enable();
    this.teleMedicineConsultForm.get('currency')?.enable();
    this.getAllPatient();
    this.userProfile = JSON.parse(localStorage.getItem('user') || '{}');
    if (this.userProfile.phone) {
      this.teleMedicineConsultForm.patchValue({
        phone: this.userProfile.phone,
      });
      this.teleMedicineConsultForm.get('phone')?.disable();
    }
    this.bookingForm = this.fb.group({
      patient: [''],
      age: [''],
      gender: [''],
      phone: [''],
      condition: [''],
      pickup: [''],
      dropup: [''],
    });
    this.getUserUnlockMedicalRecord();
  }

  ngOnInit() {
    this.bsDatepickerConfig = {
      showWeekNumbers: false,
      minDate: new Date(),
      maxDate: this.commonService.getSevenDayOrMonthEnd(),
      dateInputFormat: 'YYYY-MM-DD',
    };
    this.checkEligibility();

    this.teleMedicineConsultForm
      .get('plan_consultation')
      ?.valueChanges.subscribe((value: string) => {
        const appointmentDateCtrl =
          this.teleMedicineConsultForm.get('appointment_date');
        const slotIdCtrl = this.teleMedicineConsultForm.get('slot_id');
        if (value === 'Consult Now') {
          appointmentDateCtrl?.disable();
          appointmentDateCtrl?.setValue(null);
          slotIdCtrl?.disable();
          slotIdCtrl?.setValue(null);
        } else {
          appointmentDateCtrl?.enable();
          slotIdCtrl?.enable();
        }
      });
  }

  toggleRequiredFields(isNotRequired: boolean) {
    if (!isNotRequired) {
      this.teleMedicineConsultForm
        .get('currency')
        ?.setValidators([Validators.required]);
      this.teleMedicineConsultForm
        .get('a_la_carte_price')
        ?.setValidators([Validators.required]);
    } else {
      this.teleMedicineConsultForm.get('currency')?.clearValidators();
      this.teleMedicineConsultForm.get('a_la_carte_price')?.clearValidators();
    }
    this.teleMedicineConsultForm.get('currency')?.updateValueAndValidity();
    this.teleMedicineConsultForm
      .get('a_la_carte_price')
      ?.updateValueAndValidity();
  }

  checkEligibility() {
    this.spinner.show();
    this.apiService
      .VerifyTentureStatus({
        feature_id: 2,
        type: 'Consultant',
        user_id: this.userProfile.user_id,
      })
      .subscribe(
        (res: any) => {
          localStorage.setItem(
            'consult_status',
            String(res?.sub_tenure_status),
          );
          if (res?.sub_tenure_status === false) {
            this.notEligiblie = true;
            this.alaCartPriceOption = res?.sub_tenure_status;
            this.toggleRequiredFields(this.alaCartPriceOption);
          } else {
            setTimeout(() => {
              this.alaCartPriceOption = res?.sub_tenure_status;
              if (this.alaCartPriceOption) {
                this.teleSubsCounts();
              }
              this.commonService.addModalClosed();
              if (this.isOpenModel) {
                document.getElementById('openAddTeleModal')?.click();
              }
            }, 100);
            this.notEligiblie = false;
            this.spinner.hide();
          }
        },
        () => {
          this.spinner.hide();
          this.tosterService.error('Error checking eligibility');
        },
      );
  }

  zimbabweMobileValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let value = control?.value;
      if (!value) return { invalidZimbabweMobile: true };
      if (typeof value === 'object' && value.nationalNumber) {
        value = value.nationalNumber;
      }
      if (typeof value !== 'string') return { invalidZimbabweMobile: true };
      value = value.replace(/\s+/g, '');
      value = value.startsWith('0') ? value.substring(1) : value;
      const zimbabweMobileRegex = /^\d{9}$/;
      return zimbabweMobileRegex.test(value)
        ? null
        : { invalidZimbabweMobile: true };
    };
  }

  back() {
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.home = false;
    this.bookingConfirmed = false;
    this.router.navigate([routes.telemedi]);
  }

  getAllPatient() {
    this.spinner.show();
    this.apiService.getALLPatients().subscribe({
      next: (res: any) => {
        const allPatients = res.data || [];
        this.patientList = allPatients;
        this.spinner.hide();
      },
      error: () => {
        this.spinner.hide();
      },
    });
  }

  validateAge() {
    const ageControl = this.teleMedicineConsultForm.get('age');
    if (ageControl) {
      const value = ageControl.value;
      if (value === null || value === '') {
        return;
      }
      if (value <= 0) {
        ageControl.setValue(1, { emitEvent: false });
      }
    }
  }

  blockInvalidKeys(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  blockInvalidPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  teleSubsCounts() {
    if (this.alaCartPriceOption) {
      this.apiService.getSubTelemedCount(this.userProfile?.user_id).subscribe(
        (res: any) => {
          this.subTelemedCount = res?.data?.length || 0;
          if (this.subTelemedCount >= 12) {
            this.completeTelemedSub = true;
          }
        },
        (err: any) => {
          this.subTelemedCount = 0;
        },
      );
    }
  }

  consultationBooking() {
    if (
      localStorage.getItem('consult_status') == 'true' &&
      this.subTelemedCount >= 12
    ) {
      this.onHoldPopup = true;
    } else {
      this.onBookingTelemedicineConsultant();
    }
  }

  onBookingTelemedicineConsultant(): void {
    this.onHoldPopup = false;
    this.spinner.show();
    const formValue = this.teleMedicineConsultForm.getRawValue();
    if (formValue.phone) {
      formValue.phone.dialCode = '+263';
    }
    if (
      !formValue.patient?.user_id ||
      !formValue.consultation_type ||
      !formValue.reason_for_consultation ||
      !formValue.plan_consultation ||
      !formValue.phone?.number ||
      (formValue.phone?.number &&
        formValue.phone?.number?.toString().replace(/\s/g, '').length !== 9) ||
      !formValue.phone?.dialCode ||
      this.teleMedicineConsultForm.get('age')?.invalid ||
      (!this.alaCartPriceOption && !formValue.currency)
    ) {
      this.teleMedicineConsultForm.markAllAsTouched();
      this.spinner.hide();
      return;
    }

    const payload = {
      slot_id: formValue.slot_id,
      consultation_type: formValue.consultation_type,
      user_id: formValue.patient.user_id,
      reason_for_consultation: formValue.reason_for_consultation,
      tc_plan_type: formValue.plan_consultation,
      currency: formValue.currency,
      a_la_carte_price: formValue.a_la_carte_price,
      country_dial_code: formValue.phone.dialCode,
      phone_number: formValue?.phone?.number
        ? Number(String(formValue.phone.number).replace(/\s/g, ''))
        : null,
      is_al_carte: this.notEligiblie ? true : false,
      channel_id: 1,
      medical_report_id: formValue?.medical_report_id,
    };

    if (
      localStorage.getItem('consult_status') == 'true' &&
      this.subTelemedCount >= 12
    ) {
      payload.is_al_carte = true;
    }

    if (formValue.plan_consultation === 'Consult Now') {
      const consultNowPayload: any = {
        consultation_type: formValue.consultation_type,
        user_id: formValue.patient.user_id,
        reason_for_consultation: formValue.reason_for_consultation,
        tc_plan_type: 'Consult Now',
        is_al_carte: payload.is_al_carte,
        phone_number: formValue?.phone?.number
          ? Number(String(formValue.phone.number).replace(/\s/g, ''))
          : null,
        country_dial_code: formValue.phone.dialCode,
        channel_id: 1,
        currency: payload.is_al_carte ? formValue.currency : null,
        a_la_carte_price: payload.is_al_carte
          ? formValue.a_la_carte_price
          : null,
        caregiver_id: formValue.patient.user_id,
        medical_report_id: formValue?.medical_report_id,
      };

      if (!this.bookingId) {
        this.apiService.checkDoctorAvailability().subscribe({
          next: (availRes: any) => {
            if (!availRes?.success) {
              this.spinner.hide();
              this.tosterService.error(
                availRes?.message ||
                  'Sorry, No doctors available at this time please book your consultation after some time',
                '',
                { timeOut: 4000 },
              );
              return;
            }
            this.proceedWithConsultNowBooking(consultNowPayload, payload);
          },
          error: () => {
            this.spinner.hide();
            this.tosterService.error(
              'Unable to check doctor availability. Please try again.',
              '',
              { timeOut: 4000 },
            );
          },
        });
        return;
      }

      this.proceedWithConsultNowBooking(consultNowPayload, payload);
      return;
    } else if (this.bookingId) {
      this.apiService
        .updateTelemedicineConsultant(payload, this.bookingId)
        .subscribe({
          next: (res: any) => {
            this.spinner.hide();
            if (res?.success) {
              this.tosterService.success(
                'Telemedicine updated successfully',
                '',
                { timeOut: 4000 },
              );
              this.paymentStatus = {
                ...this.teleMedicineConsultForm.getRawValue(),
                booking_date: res.data.booking_date,
                booking_time: res.data.booking_time,
              };
              this.proceedToPay = true;
              this.slotUnavailable = false;
              this.home = false;
              this.bookingConfirmed = false;
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.tosterService.error(
                res?.message || 'Failed to telemedicine consultant.',
                '',
                { timeOut: 4000 },
              );
            }
          },
          error: (err: any) => {
            this.spinner.hide();
            this.tosterService.error(
              'Failed to add telemedicine consultant.',
              '',
              { timeOut: 4000 },
            );
            console.error('Error telemedicine consultant:', err);
          },
          complete: () => {
            this.spinner.hide();
          },
        });
    } else {
      this.apiService.bookTelemedicineConsultant(payload).subscribe({
        next: (res: any) => {
          this.spinner.hide();
          if (res?.success) {
            this.bookingId = res.data.tc_booking_id;
            const bookingData = res?.data;
            const oldStatus = 'Null';
            const newStatus = 'REQUEST';

            if (this.alaCartPriceOption) {
              if (this.subTelemedCount >= 12) {
                this.tosterService.success(
                  'Booking entry created. Please proceed to payment.',
                  '',
                  { timeOut: 4000 },
                );

                this.proceedToPay = true;
                this.slotUnavailable = false;
                this.home = false;
                this.bookingConfirmed = false;
                this.paymentStatus = {
                  ...this.teleMedicineConsultForm.getRawValue(),
                  booking_date: res.data.booking_date,
                  booking_time: res.data.booking_time,
                };
              } else {
                this.tosterService.success(
                  'Telemedicine booked successfully',
                  '',
                  { timeOut: 4000 },
                );
                this.proceedToPay = false;
                this.slotUnavailable = false;
                this.router.navigate([routes.telemedi]);
              }
            } else {
              this.tosterService.success(
                'Booking entry created. Please proceed to payment.',
                '',
                { timeOut: 4000 },
              );
              this.paymentStatus = {
                ...this.teleMedicineConsultForm.getRawValue(),
                booking_date: res.data.booking_date,
                booking_time: res.data.booking_time,
              };
              this.proceedToPay = true;
              this.slotUnavailable = false;
              this.home = false;
              this.bookingConfirmed = false;
            }

            if (
              res?.data?.tc_booking_id &&
              payload.medical_report_id &&
              payload.medical_report_id?.length > 0
            ) {
              this.spinner.show();
              const reqData: any = {
                user_id: res?.data?.user_id,
                tc_booking_id: res?.data?.tc_booking_id,
                medical_report_id: payload.medical_report_id,
              };
              this.apiService.addTelemedicineMedicalRecords(reqData).subscribe({
                next: () => {
                  this.spinner.hide();
                },
                error: (error: any) => {
                  this.spinner.hide();
                  const errorMsg =
                    error?.error?.message ||
                    error?.error?.error ||
                    'An error occurred while adding medical records.';
                  this.tosterService.error(errorMsg);
                },
              });
            }

            this.bookingLogService
              .logBookingAction(
                oldStatus,
                newStatus,
                bookingData,
                'consultation',
              )
              .subscribe({
                next: () => {
                  this.spinner.hide();
                },
                error: (error: any) => {
                  this.spinner.hide();
                  this.tosterService.error(
                    error.error.message ||
                      error.error.error ||
                      'An error occurred',
                  );
                },
              });
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.tosterService.error(
              res?.message || 'Failed to telemedicine consultant.',
              '',
              { timeOut: 4000 },
            );
          }
        },
        error: (err: any) => {
          this.spinner.hide();
          this.tosterService.error(
            'Failed to add telemedicine consultant.',
            '',
            { timeOut: 4000 },
          );
          console.error('Error Telemedicine Consultant:', err);
        },
        complete: () => {
          this.spinner.hide();
        },
      });
    }

    this.isOpenModel = this.alaCartPriceOption ? false : true;
    this.checkEligibility();
    const currentDate = new Date();
    this.paymentStatus = {
      ...this.teleMedicineConsultForm.getRawValue(),
      booking_date: currentDate,
    };
  }

  private proceedWithConsultNowBooking(
    consultNowPayload: any,
    payload: any,
  ): void {
    this.apiService.bookConsultNowTelemedicine(consultNowPayload).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res?.success) {
          this.bookingId = res.data.tc_booking_id;

          if (payload.is_al_carte) {
            this.tosterService.success(
              'Booking entry created. Please proceed to payment.',
              '',
              { timeOut: 4000 },
            );
            this.paymentStatus = {
              ...this.teleMedicineConsultForm.getRawValue(),
              booking_date: res.data?.booking_date || null,
              booking_time: res.data?.booking_time || 'Immediate',
            };
            this.proceedToPay = true;
            this.slotUnavailable = false;
            this.home = false;
            this.bookingConfirmed = false;
          } else {
            this.tosterService.success('Telemedicine booked successfully', '', {
              timeOut: 4000,
            });
            this.proceedToPay = false;
            this.slotUnavailable = false;
            this.router.navigate([routes.telemedi]);
          }

          if (
            res?.data?.tc_booking_id &&
            consultNowPayload.medical_report_id &&
            consultNowPayload.medical_report_id?.length > 0
          ) {
            this.spinner.show();
            const reqData: any = {
              user_id: res?.data?.user_id,
              tc_booking_id: res?.data?.tc_booking_id,
              medical_report_id: consultNowPayload.medical_report_id,
            };
            this.apiService.addTelemedicineMedicalRecords(reqData).subscribe({
              next: () => {
                this.spinner.hide();
              },
              error: (error: any) => {
                this.spinner.hide();
                const errorMsg =
                  error?.error?.message ||
                  error?.error?.error ||
                  'An error occurred while adding medical records.';
                this.tosterService.error(errorMsg);
              },
            });
          }

          this.bookingLogService
            .logBookingAction('Null', 'REQUEST', res?.data, 'consultation')
            .subscribe({
              next: () => {
                this.spinner.hide();
              },
              error: (error: any) => {
                this.spinner.hide();
                this.tosterService.error(
                  error.error.message ||
                    error.error.error ||
                    'An error occurred',
                );
              },
            });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.tosterService.error(
            res?.message || 'Failed to book consultation.',
            '',
            { timeOut: 4000 },
          );
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.tosterService.error('Failed to book consultation.', '', {
          timeOut: 4000,
        });
        console.error('Error Consult Now Telemedicine:', err);
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  allowOnlyDigits(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onInput(index: number, event: any): void {
    const input = event.target;
    const value = input.value;

    if (!/^\d$/.test(value)) {
      input.value = '';
      return;
    }
    this.pinForm.get('pin' + index)?.setValue(value);
    setTimeout(() => {
      input.value = this.showPin ? value : '*';
    }, 10);
    const next = input.nextElementSibling;
    if (next) next.focus();
  }

  onKeyDown(index: number, event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = this.pinInputs.get(index - 1);
      prevInput?.nativeElement.focus();
    }
  }

  get ageCtrl() {
    return this.teleMedicineConsultForm.get('age');
  }

  onSubmit(): void {
    if (!this.pinForm.valid) {
      Object.keys(this.pinForm.controls).forEach((control) =>
        this.pinForm.get(control)?.markAsTouched(),
      );
      return;
    }

    this.spinner.show();

    if (this.paymentStatus?.slot_id && this.paymentStatus?.slot_id !== 'N/A') {
      this.checkSlotAvailability(this.paymentStatus.slot_id, () => {
        this.proceedWithPinValidation();
      });
      return;
    }

    this.proceedWithPinValidation();
  }

  private proceedWithPinValidation(): void {
    const validatePin = () => {
      const pin = Object.values(this.pinForm.value).join('');
      const payload = {
        phone: this.billingNumber,
        userId: this.paymentStatus.patient.user_id,
        bookingId: this.bookingId,
        alaCartePrice: this.paymentStatus.a_la_carte_price,
        channelId: 1,
        paymentGateway: 'Ecocash',
        featureService: 'Telemedicine Consultations',
        currency: this.paymentStatus.currency || 'ZWG',
        userPin: pin,
      };

      this.apiService.pinValidate(payload).subscribe(
        (res: any) => {
          this.spinner.hide();
          handleSubscriptionResponse(res, this.tosterService);
          if (res.status) {
            this.errorMessage = '';
            this.statusCode = res.data.responseCode;
            if (res.data.responseCode == '00') {
              // ✅ '00' means the PIN is correct, so booking is confirmed
              setTimeout(() => this.getAlaCarteDetails(), 0);
            } else {
              if (
                ['32012', '20006', '20001', '20005', '002100'].includes(
                  res.data.responseCode,
                )
              ) {
                this.enterEcocashPIn = false;
                this.bookingConfirmed = false;
                this.ErrorPin = false;
                this.IncorrectPin = false;

                switch (res.data.responseCode) {
                  case '20001': // Invalid mobile number or PIN
                    this.attemptsLeft = 2;
                    this.IncorrectPin = true;
                    break;
                  case '20006': // Incorrect PIN, near account lock
                    this.attemptsLeft = 1;
                    this.IncorrectPin = true;
                    break;
                  case '20005': // Account is blocked
                    this.ErrorPin = true;
                    break;
                  case '002100': // General Error
                    this.errorMessage = res.message;
                    this.ErrorPin = true;
                    break;
                }

                this.startTimer();
              } else {
                this.spinner.hide();
                this.enterEcocashPIn = false;
                this.bookingConfirmed = false;
                this.IncorrectPin = false;
                this.ErrorPin = true;
              }
            }
          } else {
            this.spinner.hide();
            this.tosterService.error('Somthing went wrong', '', {
              timeOut: 4000,
            });
          }
          this.spinner.hide();
        },
        (err: any) => {
          this.bookingConfirmed = false;
          this.IncorrectPin = false;
          this.enterEcocashPIn = false;
          this.ErrorPin = true;
          this.spinner.hide();
          this.tosterService.error('PIN validation failed', '', {
            timeOut: 4000,
          });
        },
      );
    };

    validatePin();
  }

  getAlaCarteDetails() {
    this.spinner.show();
    let inProgressExist: boolean = true;
    const polling$ = interval(1000).pipe(
      switchMap(() => this.apiService.getTelemedicineById(this.bookingId)),
      takeWhile((res: any) => {
        return (
          res?.data?.ConsultAlaCartePayment?.payment_status !== 'Success' &&
          res?.data?.ConsultAlaCartePayment?.payment_status !== 'Failed'
        );
      }, true),
      takeUntil(timer(10000)),
    );

    polling$.subscribe({
      next: (res: any) => {
        if (res?.data?.ConsultAlaCartePayment?.payment_status === 'Success') {
          this.spinner.hide();
          this.bookingConfirmed = 'success';
          this.enterEcocashPIn = false;
          this.ErrorPin = false;
          inProgressExist = false;
        } else if (
          res?.data?.ConsultAlaCartePayment?.payment_status === 'Failed'
        ) {
          this.spinner.hide();
          this.enterEcocashPIn = false;
          this.ErrorPin = false;
          inProgressExist = false;
          this.bookingConfirmed = 'failed';

          const rawRemark = res?.data?.ConsultAlaCartePayment?.remark || '';
          this.remark = rawRemark.replace(/^ProcessingException:/i, '').trim();
        } else {
          inProgressExist = true;
        }
      },
      error: (err: any) => {
        console.error('Error fetching AlaCarte details:', err);
        this.spinner.hide();
      },
      complete: () => {
        console.log(
          'Polling completed (either status received or timeout reached).',
        );
        this.spinner.hide();
        if (inProgressExist) {
          this.bookingConfirmed = 'progress';
          this.enterEcocashPIn = false;
          this.ErrorPin = false;
        }
      },
    });
  }

  startTimer(): void {
    this.clearTimer();
    this.timeElapsed = 0;
    this.timer = setTimeout(() => {
      this.IncorrectPin = false;
      this.ErrorPin = true;
    }, this.timeoutLimit);
  }

  clearTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  proceedToPays(event?: any): void {
    this.billingNumber =
      event || this.userProfile?.billing_number || this.userProfile?.phone;
    this.IncorrectPin = false;
    this.enterEcocashPIn = true;
    this.pinForm.reset();
    this.clearTimer();
  }

  onCheckEl() {
    this.billingNumber = this.userProfile.billing_number
      ? this.userProfile.billing_number
      : this.paymentStatus.patient.phone;

    this.spinner.show();

    if (this.paymentStatus?.slot_id && this.paymentStatus?.slot_id !== 'N/A') {
      this.checkSlotAvailability(this.paymentStatus.slot_id, () => {
        this.continuePaymentFlow();
      });
      return;
    }

    this.continuePaymentFlow();
  }

  continuePaymentFlow() {
    this.spinner.hide();
    if (!this.notEligiblie && this.subTelemedCount < 12) {
      this.onBookingTelemedicineConsultant();
    } else {
      this.enterEcocashPIn = true;
      this.proceedToPay = false;
      this.slotUnavailable = false;
    }
    this.pinForm.reset();
  }

  closeApology() {
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.home = false;
    this.bookingConfirmed = false;
    this.teleMedicineConsultForm.reset();
    this.router.navigate([routes.telemedi]);
  }

  getSlotsData(ev: any): void {
    if (ev) {
      const updatedAppointmentDate = moment(ev).format('YYYY-MM-DD');
      this.teleMedicineConsultForm
        .get('appointment_date')
        .setValue(updatedAppointmentDate);
      const consultationType =
        this.teleMedicineConsultForm.get('consultation_type')?.value;
      let consultTypeId = null;
      if (consultationType == 'Consult with General Physician') {
        consultTypeId = 1;
      } else if (consultationType == 'Consult with Herbalist') {
        consultTypeId = 2;
      }

      const data = {
        consultation_type: consultTypeId,
        date: updatedAppointmentDate,
      };

      this.apiService.getSlots(data).subscribe((res: any) => {
        this.slotsList = res.data || [];

        const isSlotExist = this.slotsList.some(
          (el) => el?.slot_id == this.teleMedicineConsultForm?.value['slot_id'],
        );

        if (!isSlotExist) {
          this.teleMedicineConsultForm.get('slot_id').setValue(null);
        }
      });
    }
  }

  goToHome() {
    this.bookingConfirmed = false;
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.home = false;
    this.router.navigate([routes.telemedi]);
  }

  cleanInput(event: KeyboardEvent) {
    const key = event.key;
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const isLetter = /^[a-zA-Z]$/.test(key);
    const isSpace = key === ' ';
    const isControlKey = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ].includes(key);

    if (
      !isLetter &&
      !(isSpace && value.length > 0 && !value.endsWith(' ')) &&
      !isControlKey
    ) {
      event.preventDefault();
    }
  }

  getCurrencyPrice() {
    const form2 = this.teleMedicineConsultForm;
    const currency = form2.get('currency')?.value;
    const payload = {
      currency: currency,
      feature_name: 'Telemedicine Consultations',
    };
    this.apiService.getAlacartePrice(payload).subscribe((res: any) => {
      let a_la_carte_price = res.data.a_la_carte_price;
      form2.get('a_la_carte_price')?.disable();
      form2.patchValue({ a_la_carte_price: a_la_carte_price });
      this.currencyPrice = res.data.a_la_carte_price;
    });
  }

  onPhoneInput(event: any): void {
    const input = event.target.value;
    const cleanedValue = input.replace(/\D/g, '');
    event.target.value = cleanedValue;
  }

  onPatientChange(text: any) {
    const form = this.teleMedicineConsultForm;
    const patient = form.get('patient')?.value;
    if (!patient) return;

    const { gender, dob, booking_date, booking_time } = patient;

    // Clean up
    delete patient.booking_date;
    delete patient.booking_time;

    // Calculate age
    let age = null;
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
    }

    form.patchValue({
      gender: gender?.toLowerCase() || '',
      age,
    });

    form.get('gender')?.enable();

    if (gender) {
      form.get('gender')?.disable();
    }

    form.get('age')?.enable();
    if (age !== null) {
      form.get('age')?.disable();
    }
  }

  moveToHomeScreen() {
    this.home = false;
    this.ErrorPin = false;
    this.bookingConfirmed = false;
    this.IncorrectPin = false;
    this.proceedToPay = false;
    this.slotUnavailable = false;
    this.pinForm.reset();
    this.attemptsLeft = 3;
    this.router.navigate([routes.telemedi]);
  }

  getUserUnlockMedicalRecord() {
    this.spinner.show();
    this.userProfiles = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = this.userProfiles?.user_id;
    this.apiService.getUserUnlockMedicals(userId).subscribe(
      (res: any) => {
        this.unlockMedicalList = res.data.map((item: any) => {
          let displayText = '';

          if (item.type === 'prescription') {
            const doctorName = item?.doctor
              ? `${item.doctor.first_name} ${item.doctor.last_name}`
              : 'Unknown Doctor';

            displayText = `Prescription - Dr ${doctorName}`;
          } else {
            const recordType = item.MedicalRecordType?.report_type || 'Record';
            displayText = `${recordType} - ${item.symptoms || ''}`;
          }

          return {
            value: {
              id: item.id,
              type: item.type,
            },
            displayText,
          };
        });

        this.spinner.hide();
      },
      (err: any) => {
        console.error('Error fetching medical record types:', err);
        this.spinner.hide();
      },
    );
  }

  togglePinVisibility(): void {
    this.showPin = !this.showPin;

    this.pinInputs.forEach((inputRef, index) => {
      const input = inputRef.nativeElement;
      const value = this.pinForm.get('pin' + index)?.value;

      if (value) {
        input.value = this.showPin ? value : '*';
      }
    });
  }

  checkSlotAvailability(slotId: string, onSuccess?: () => void): void {
    this.apiService.getSlotCount(slotId).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res?.success) {
          const countData = res?.data?.booking_counts;

          if (countData >= 3) {
            this.slotUnavailable = true;
            this.proceedToPay = false;
            this.enterEcocashPIn = false;
            this.pinForm.reset();
            this.bookingConfirmed = false;

            return;
          }

          if (onSuccess) {
            onSuccess();
          }
        }
      },
      () => {
        this.spinner.hide();
        this.tosterService.error('Something went wrong!');
      },
    );
  }

  closeProceedPayment() {
    this.pinForm.reset();
    this.slotUnavailable = false;
    this.proceedToPay = false;
    this.enterEcocashPIn = false;
    this.home = false;
    this.bookingConfirmed = false;
    this.router.navigate([routes.telemedi]);
  }
}
